export const DO_DECLINE_START = "DO_DECLINE_START";
export const DO_DECLINE_SUCCESS = "DO_DECLINE_SUCCESS";
export const DO_DECLINE_FAILURE = "DO_DECLINE_FAILURE";